import { Injectable, Signal } from '@angular/core';
import { Project, ProjectFacadeInterface } from '@web-portal/domains/shared/domain-models';

@Injectable()
export abstract class ProjectFacadeStrategy<P = Project> implements ProjectFacadeInterface<P> {
  abstract projects: Signal<P[]>;
  abstract selectedProject: Signal<P | null>;
  abstract projectIfcFilesToUpload: Signal<File[]>;
  // its probably not valid for the greenfield
  // project but is not clear at the moment how to solve this
  abstract projectSignalrService: unknown;

  abstract projectName: Signal<string>;
  abstract isProjectAdmin: Signal<boolean>;
  abstract isProjectEditor: Signal<boolean>;
  abstract isProjectViewer: Signal<boolean>;
}
